import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HomePageBanner from "../../Components/HomePageBanner/HomePageBanner";
import IdentityLogin from "../../Components/IdentityLogin/IdentityLogin";
import Page from "../../Components/MetaPage/Page";
import { getRemoteValue } from "../../Utils/firebase";
import { sendEvent } from "../../Utils/firebaseLogger";


const IdentityLoginPage = () => {

  const navigate = useNavigate();
  const [isLoadLogged, setIsLoadLogged] = useState(false);

  useEffect(() => {

    navigate("/")

    if (!isLoadLogged) {
      setIsLoadLogged(true);
      sendEvent(`view_landing_page`, {});
    }
  }, []);

  return (
    <Page title={getRemoteValue("payments")}>
      <Box
        sx={{
          minHeight: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: "32px",
          paddingBottom: "48px",
          paddingX: "16px",
          "@media (min-width: 768.5px)": {
            minHeight: "calc(90vh)",
            paddingTop: 0,
            paddingBottom: 0,
            paddingX: 0,
          },
        }}
      >
        <Grid container sx={{ flexGrow: 1 }}>
          <Grid
            item
            xs={12}
            lg={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <IdentityLogin />
          </Grid>
          <Grid
            item
            className="hidden lg:flex items-center justify-center relative"
            xs={12}
            lg={6}
          >
            <HomePageBanner />
          </Grid>
        </Grid>
      </Box>
    </Page>
  );
};

export default IdentityLoginPage;
